module.exports = __webpack_public_path__ + "img/Capa Foca no Enem .8c928d0a.png";